<ion-button
  [expand]="ionExpand()"
  [type]="type()"
  [form]="form()"
  [disabled]="isDisabled()"
  [fill]="fill()"
  [color]="color()"
  [size]="size()"
  [class]="classes()"
  (click)="onClick()"
>
  @if (loading()) {
  <ion-spinner name="crescent"></ion-spinner>
  <span>{{ loadingText() || label() }}</span>
  } @else {
  <ng-content>{{ label() }}</ng-content>
  }
</ion-button>
